
export const Arbitrum = {
  rpc: 'https://arb1.arbitrum.io/rpc',
  scan: 'https://arbiscan.io/',
  chainName: 'Arbitrum',
  tokenScan: 'https://arbiscan.io/token/',
  id: 42161,
  main: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
    icon: 'https://cdn.wherein.mobi/wormhole3/logo/ZjT_zBAS_400x400.png'
  },
  Multi_Config: {
    rpcUrl: 'https://arb1.arbitrum.io/rpc',
    multicallAddress: '0x4B6EF997DbF23D320a6616ADf6499f4cdC00AB7c',
    interval: 3000
  }
}

export const MFERC = "0xDB78c8B524Aa2D836Cb8C2868Be01A14b7E13863"; // test

export const CHAIN_ID = 42161

